import { axiosCashJournalClient } from "../api";
import { APP_ID } from "../config";

import { ApplicationInfoResponseType, GetListResponseRolesType, RBACRoleApplicationsResponseType } from "./types";

const url = "bb-one/rbac/v1";

export const getRBACConfig = async (roleID: string) => {
  const { data } = await axiosCashJournalClient({
    url: `${url}/applications/${APP_ID}/menus?roleId=${roleID}`,
    method: "GET",
  });

  return data;
};

export const getRBACRoles = async () => {
  const { data } = await axiosCashJournalClient({
    url: `${url}/applications/${APP_ID}/user-roles`,
    method: "GET",
  });

  return data;
};

export const getUserRoles = async (): Promise<GetListResponseRolesType> => {
  const { data } = await axiosCashJournalClient({
    url: `${url}/roles/app_id/${APP_ID}`,
    method: "GET",
  });

  return data;
};

export const getRBACApplications = async (): Promise<RBACRoleApplicationsResponseType> => {
  const { data } = await axiosCashJournalClient({
    url: `${url}/users/role-applications`,
    method: "GET",
  });

  return data;
};

export const getRBACAppByAppId = async (): Promise<ApplicationInfoResponseType> => {
  const { data } = await axiosCashJournalClient({
    url: `${url}/applications/${APP_ID}`,
    method: "GET",
  });

  return data;
};
